"use client"

import * as React from "react"
import { format } from "date-fns"
import { Calendar as CalendarIcon } from "lucide-react"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

export function DatePicker({ date, setDate, placeholder = "Pick a date", className }) {
  const [open, setOpen] = React.useState(false)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            "w-full justify-start text-left font-normal bg-white border-[#C9D4E6] hover:bg-[#EDF1F8] hover:text-[#14213D]",
            !date && "text-muted-foreground",
            className
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4 text-[#A87608]" />
          {date ? format(date, "dd MMM yyyy") : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-white border-[#C9D4E6]" align="start">
        <Calendar
          mode="single"
          selected={date}
          onSelect={(d) => {
            setDate(d)
            setOpen(false)
          }}
          initialFocus
          className="bg-white text-[#1B2A4A]"
          classNames={{
            caption: "flex justify-center pt-1 relative items-center text-[#14213D]",
            caption_label: "text-sm font-medium text-[#14213D]",
            nav: "space-x-1 flex items-center",
            nav_button: "h-7 w-7 bg-transparent p-0 text-[#44506B] hover:text-[#14213D]",
            nav_button_previous: "absolute left-1",
            nav_button_next: "absolute right-1",
            table: "w-full border-collapse space-y-1",
            head_row: "flex",
            head_cell: "text-[#5A6880] rounded-md w-9 font-normal text-[0.8rem]",
            row: "flex w-full mt-2",
            cell: "h-9 w-9 text-center text-sm p-0 relative",
            day: "h-9 w-9 p-0 font-normal text-[#1B2A4A] hover:bg-[#EDF1F8] rounded-md",
            day_selected: "bg-[#D4A017] text-white hover:bg-[#9C6C16] hover:text-white focus:bg-[#D4A017] focus:text-white rounded-md",
            day_today: "bg-[#EDF1F8] text-[#A87608] font-semibold",
            day_outside: "text-[#B6BFCE] opacity-50",
            day_disabled: "text-[#B6BFCE] opacity-50",
            day_hidden: "invisible",
          }}
        />
      </PopoverContent>
    </Popover>
  )
}
